import { render, staticRenderFns } from "./AddServices.vue?vue&type=template&id=bc898a22&scoped=true"
import script from "./AddServices.vue?vue&type=script&lang=js"
export * from "./AddServices.vue?vue&type=script&lang=js"
import style0 from "./AddServices.vue?vue&type=style&index=0&id=bc898a22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc898a22",
  null
  
)

export default component.exports